module.exports = __webpack_public_path__ + "static/media/bio_age_sto_lab.6a4cdb84.png";